

export class Search {

	searchBtns: NodeListOf<HTMLElement>;
	searchField: HTMLInputElement;

	constructor() {
		this.searchBtns = document.querySelectorAll('a.search-link');
		this.searchField = document.querySelector('form .search-field')

		this.searchBtns.forEach( (el) => el.addEventListener('click', () => this.searchField.focus()));
	}

}

